<div class="info-accordion" id="owner">
  <h2 class="pt-5 pb-4 mb-0">
    <span class="title_2">{{ "PROCESSES.ACCOMMODATION.LIST.OWNER" | translate }}</span>
  </h2>

  <div class="d-flex flex-row align-items-center gap-8 pb-2 subtitle_1 txt-darkGray">
    <lf-icon class="margin-check" name="partnerVerif" width="18px" height="18px" fillColor="#002FA7"></lf-icon>
    <h3 class="subtitle_1">{{ 'ROOM.ADVANTAGES.LIVIN_PARTNER' | translate }}</h3>
    <lf-icon name="question" class="margin-check" width="18px" height="18px" fillColor="#FFFFFF"
      [placement]="isMobile ? 'top-end' : 'top-start'"
      ngbTooltip="{{ 'ROOM.ADVANTAGES.PARTNER_TOOLTIP' | translate }}" tooltipClass="owner-tooltip"></lf-icon>

  </div>

  <div *ngIf="room.partner.tenants && room.partner.tenants > 5" class="d-flex flex-row align-items-center gap-8 pb-1 text_1">
      <lf-icon class="icon-check" name="Verif" width="8px" height="8px" fillColor="#00C49A"></lf-icon>
      {{ 'ROOM.ADVANTAGES.SATISFIED_TENANT' | translate: {value: room.partner.tenants ? room.partner.tenants : 0}  }}
  </div>

  <div class="d-flex flex-row align-items-center gap-8 pb-1 text_1">
      <lf-icon class="icon-check" name="Verif" width="8px" height="8px" fillColor="#00C49A"></lf-icon>
      {{ 'ROOM.ADVANTAGES.PARTNER_DATE' | translate: {value: room.partner.created_at | date: 'y'}  }}
  </div>

  <div class="d-flex flex-row align-items-center gap-8 text_1">
      <lf-icon class="icon-check" name="Verif" width="8px" height="8px" fillColor="#00C49A"></lf-icon>
      {{ 'ROOM.ADVANTAGES.LANGUAGES' | translate  }}

      <span *ngFor="let language of languages" class="margin-check">
      <lf-icon name="{{language}}" width="18px" height="18px"></lf-icon>
  </span>
  </div>


  <!-- Horaires check-in -->

  <div class="subtitle_1 pt-4 pb-2 mb-0">
    <h3 class="subtitle_1">
      {{ "PROCESSES.ACCOMMODATION.LIST.CHECK_IN" | translate }}
    </h3>
  </div>

  <div class="d-flex pt-3 pb-4 overflow-auto hidden-scrollbar">
    <div class="d-inline days-list" *ngFor="let date of checkInArray; let index = index">
      <div class="days-btn rounded-pill title_3" (click)="toggleCheckIn(index)" [ngClass]="{'active': actualIndex === index}">
        {{ ('COMMON.' + date) | translate }}
      </div>
    </div>
  </div>

  <div class="w-100">
    <div class="row">
      <div class="col text_1">
        <span class="col-4 mx-0 px-0 hourly_check-in">{{ 'COMMON.MORNING' | translate }} : </span>
        <span class="title_3 col-4 mx-0 px-0">{{ room.checkin && room.checkin[actualIndex].morning ? room.checkin[actualIndex].morning : 'N/A' }}</span>
      </div>

      <div class="col text_1">
        <span class="col-4 mx-0 px-0 hourly_check-in">{{ 'COMMON.AFTERNOON' | translate }} : </span>
        <span class="title_3 col-4 mx-0 px-0">{{ room.checkin && room.checkin[actualIndex].afternoon ? room.checkin[actualIndex].afternoon : 'N/A' }}</span>
      </div>
    </div>
  </div>

</div>
